import { render, staticRenderFns } from "./order-pay.vue?vue&type=template&id=202b3488&scoped=true"
import script from "./order-pay.vue?vue&type=script&lang=js"
export * from "./order-pay.vue?vue&type=script&lang=js"
import style0 from "./order-pay.vue?vue&type=style&index=0&id=202b3488&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202b3488",
  null
  
)

export default component.exports